// src/utils/transformProductData.js

import {
  displayCategoryLabel,
  displayFamilyLabel,
  displayProductLabel
} from './demoProductLabels.js';

export const transformProductData = (rawData) => {
  console.log("rawData: ", rawData)
  // 1) categoryMap and grouped‐by‐family initialization remain unchanged
  const categoryMap = {
    LF: "FP",
    LS: "SP",
    LA: "Accessories",
    OT: "Accessories",
    MF: "Moto-FP",
  };

  // Prepare an object of sets: grouped[“FP”] = { familyA: Set(models…), familyB: Set(models…), … }
  const grouped = {
    FP: {},
    SP: {},
    Accessories: {},
    "Moto-FP": {},
    Others: {}
  };

  rawData.forEach((item) => {
    if (item.is_snop !== 1) return;                // same filter as before
    const rawCat = (item.category || "").toString();
    const rootKey = categoryMap[rawCat] || "Others";
    if (!rootKey) return;

    if (!grouped[rootKey][item.family]) {
      grouped[rootKey][item.family] = new Set();
    }
    grouped[rootKey][item.family].add(item.model_code);
  });

  // 2) idCounter will generate a unique base ID for each root node
  let idCounter = 1;
  const result = [];
  result['menu'] = [];
  result['sop_data'] = [];

  for (const [rootName, families] of Object.entries(grouped)) {
    // Skip categories with no families
    if (Object.keys(families).length === 0) continue;
    const displayRootName = displayCategoryLabel(rootName);

    result['sop_data'][displayRootName] = [];

    // Assign a unique id to this root
    const rootId = idCounter++;
    const root = {
      id: rootId,
      name: displayRootName,
      subMenu: []
    };

    // 3) Now iterate over each family. We incorporate a small "familyIndex" 
    //    so that each family ID under this root is (rootId * 10) + familyIndex,
    //    making sure they differ even if families happen to share the same name.
    let familyIndex = 1;
    for (const [familyName, modelsSet] of Object.entries(families)) {
      const displayFamilyName = displayFamilyLabel(familyName);

      const sopDataModelsCat = {
        name: displayFamilyName,
        models: []
      }

      // e.g. if rootId = 2 and this is the first family, familyId = 2*10 + 1 = 21
      //      second family → 2*10 + 2 = 22, etc.
      const familyId = rootId * 10 + familyIndex++;
      const familyNode = {
        id: familyId,
        name: displayFamilyName,
        subMenu: []
      };

      // 4) Finally, assign each model under this family a unique ID as well.
      //    We do (familyId * 10) + modelIndex. So if familyId = 21, the models become 210+1=211, 210+2=212, etc.
      let modelIndex = 1;
      Array.from(modelsSet).forEach((modelCode) => {
        const modelId = familyId * 10 + modelIndex++;
        familyNode.subMenu.push({
          id: modelId,
          name: displayProductLabel(modelCode),
          modelCode,
        });

        sopDataModelsCat.models.push(modelCode);
      });

      root.subMenu.push(familyNode);
      result['sop_data'][displayRootName].push(sopDataModelsCat);
    }

    result['menu'].push(root);
  }

  return result;
};
